import type { RiskGapModel } from '@ctw/shared/api/fhir/models/risk-gap';
import type { BadgeProps } from '@ctw/shared/components/badge';
import { faClock, faClockRotateLeft } from '@fortawesome/pro-regular-svg-icons';
import { faCheck, faXmark } from '@fortawesome/pro-solid-svg-icons';

export const riskGapStatusBadgeDefinition = (riskGap: RiskGapModel): BadgeProps => {
  switch (riskGap.status) {
    case 'pending': {
      return {
        variant: 'info-secondary',
        content: 'Pending',
        icon: faClockRotateLeft,
        testId: 'risk-gap-status-badge-pending',
      };
    }
    case 'dismissed': {
      return {
        variant: 'meta-secondary',
        content: 'Dismissed',
        icon: faXmark,
        iconVariant: 'error',
        testId: 'risk-gap-status-badge-dismissed',
      };
    }
    case 'expected-to-close': {
      return {
        variant: 'meta-secondary',
        content: 'Expected to close',
        icon: faCheck,
        iconVariant: 'success',
        testId: 'risk-gap-status-badge-expected-to-close',
      };
    }
    case 'closed-by-payer-file': {
      return {
        variant: 'meta-secondary',
        content: 'Closed',
        icon: faCheck,
        iconVariant: 'success',
        testId: 'risk-gap-status-badge-closed-by-payer-file',
      };
    }
    case 'closed-gap': {
      return {
        variant: 'meta-secondary',
        content: 'Closed',
        icon: faCheck,
        iconVariant: 'success',
        testId: 'risk-gap-status-badge-closed-by-payer-file',
      };
    }
    case 'closed-by-claims-file': {
      return {
        variant: 'meta-secondary',
        content: 'Closed',
        icon: faCheck,
        iconVariant: 'success',
        testId: 'risk-gap-status-badge-closed-by-claims-file',
      };
    }
    case 'closed-unspecified': {
      return {
        variant: 'meta-secondary',
        content: 'Closed',
        icon: faCheck,
        iconVariant: 'success',
        testId: 'risk-gap-status-badge-closed-unspecified',
      };
    }
    case 'accepted-for-review': {
      return {
        variant: 'meta-secondary',
        content: 'Accepted for review',
        icon: faCheck,
        iconVariant: 'success',
        testId: 'risk-gap-status-badge-accepted-for-review',
      };
    }
    default: {
      return {
        variant: 'caution-secondary',
        content: 'Open',
        icon: faClock,
        testId: 'risk-gap-status-badge-open',
      };
    }
  }
};
